import React from "react";
import PublicInfoLayout from "./PublicInfoLayout";

const quickFaq = [
  {
    q: "¿Tengo que saber de finanzas para usarla?",
    a: "No. Está pensada para seguir un flujo guiado y revisar tus números con lenguaje sencillo.",
  },
  {
    q: "¿Qué necesito para empezar?",
    a: "Tu cuenta en la app y un extracto de cuenta o tarjeta en CSV/XLSX.",
  },
  {
    q: "¿En cuánto tiempo veo algo útil?",
    a: "Normalmente en pocos minutos ya puedes ver ingresos, gastos y primeras categorías.",
  },
];

const howToStructuredData = {
  "@context": "https://schema.org",
  "@type": "HowTo",
  name: "Cómo empezar en 5 minutos con Ahorra y respira",
  description: "Pasos para configurar fuentes, importar extractos, categorizar y revisar análisis.",
  totalTime: "PT5M",
  step: [
    { "@type": "HowToStep", name: "Configura tus fuentes", text: "Crea tu cuenta bancaria y tarjeta en Configuración inicial." },
    { "@type": "HowToStep", name: "Sube un extracto", text: "Importa un CSV/XLSX de cuenta o tarjeta desde Subir datos." },
    { "@type": "HowToStep", name: "Categoriza lo esencial", text: "Aplica reglas y corrige movimientos sin categoría." },
    { "@type": "HowToStep", name: "Revisa análisis y ahorro", text: "Analiza gastos e ingresos y ajusta tu plan de ahorro." },
  ],
  url: "https://ahorrayrespira.com/como-empezar-en-5-minutos",
  inLanguage: "es-ES",
};

const faqStructuredData = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: quickFaq.map(item => ({
    "@type": "Question",
    name: item.q,
    acceptedAnswer: { "@type": "Answer", text: item.a },
  })),
};

export default function GetStartedFiveMinutesPage() {
  return (
    <PublicInfoLayout
      title="Cómo empezar en 5 minutos"
      subtitle="Pasos concretos para tener tus primeras métricas sin perder una tarde entera."
      updatedAt="18 de febrero de 2026"
      canonicalPath="/como-empezar-en-5-minutos"
      structuredData={[howToStructuredData, faqStructuredData]}
    >
      <section className="panel">
        <h2 className="panel-title">Paso 1: Configura tus fuentes</h2>
        <p>Entra en "Configuración inicial", crea tu cuenta bancaria y tu tarjeta con nombres claros.</p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Paso 2: Sube un extracto</h2>
        <p>Importa un archivo CSV/XLSX de cuenta o tarjeta desde "Subir datos".</p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Paso 3: Categoriza lo esencial</h2>
        <p>Aplica reglas y corrige solo los movimientos sin categoría para acelerar todo el proceso.</p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Paso 4: Revisa análisis y plan de ahorro</h2>
        <p>Comprueba en qué se te va el dinero y fija un presupuesto mensual realista por categoría.</p>
      </section>

      <section className="panel">
        <h2 className="panel-title">Preguntas frecuentes rápidas</h2>
        <div className="cards-grid" style={{ marginTop: "1rem" }}>
          {quickFaq.map(item => (
            <article className="card" key={item.q}>
              <strong>{item.q}</strong>
              <p>{item.a}</p>
            </article>
          ))}
        </div>
      </section>
    </PublicInfoLayout>
  );
}
